module.exports = __webpack_public_path__ + "static/media/11.0563369f.png";